import { css } from 'styled-components';
import type { DoubleSpacing, SpacingKey } from 'ui/styles/config/spacing';
import { spacingToStyle } from 'ui/styles/utils';

import type { PrefixWithDollar } from '../../../types/helpers';

interface SpacingProps {
  margin?: DoubleSpacing;
  marginTop?: SpacingKey;
  marginBottom?: SpacingKey;
  marginLeft?: SpacingKey;
  marginRight?: SpacingKey;
  padding?: DoubleSpacing;
  paddingTop?: SpacingKey;
  paddingBottom?: SpacingKey;
  paddingLeft?: SpacingKey;
  paddingRight?: SpacingKey;
}

type StyledSpacingProps = PrefixWithDollar<SpacingProps>;

/* prettier-ignore */
export const SpacingStyles = css<StyledSpacingProps>`
  ${({ theme, $margin }) =>
    $margin &&
    css`
    margin: ${spacingToStyle(theme, $margin)};
  `};
  ${({ theme, $marginTop }) =>
    $marginTop &&
    css`
    margin-top: ${theme.spacing[$marginTop]};
  `};
  ${({ theme, $marginBottom }) =>
    $marginBottom &&
    css`
    margin-bottom: ${theme.spacing[$marginBottom]};
  `};
  ${({ theme, $marginLeft }) =>
    $marginLeft &&
    css`
    margin-left: ${theme.spacing[$marginLeft]};
  `};
  ${({ theme, $marginRight }) =>
    $marginRight &&
    css`
    margin-right: ${theme.spacing[$marginRight]};
  `};

  ${({ theme, $padding }) =>
    $padding &&
    css`
    padding: ${spacingToStyle(theme, $padding)};
  `};
  ${({ theme, $paddingTop }) =>
    $paddingTop &&
    css`
    padding-top: ${theme.spacing[$paddingTop]};
  `};
  ${({ theme, $paddingBottom }) =>
    $paddingBottom &&
    css`
    padding-bottom: ${theme.spacing[$paddingBottom]};
  `};
  ${({ theme, $paddingLeft }) =>
    $paddingLeft &&
    css`
    padding-left: ${theme.spacing[$paddingLeft]};
  `};
  ${({ theme, $paddingRight }) =>
    $paddingRight &&
    css`
    padding-right: ${theme.spacing[$paddingRight]};
  `};
`;

export const toStyledSpacingProps = (
  props: SpacingProps,
): StyledSpacingProps => {
  const styledProps: StyledSpacingProps = {};
  const restProps: { [key: string]: any } = { ...props };
  Object.entries(props).forEach(([key, value]) => {
    if (key.startsWith('margin') || key.startsWith('padding')) {
      const styledKey = `$${key}` as keyof StyledSpacingProps;
      styledProps[styledKey] = value;
      delete restProps[key];
    }
  });
  return {
    ...restProps,
    ...styledProps,
  };
};

export type { SpacingProps, StyledSpacingProps as SpacingStyledProps };
